module.exports = __webpack_public_path__ + "img/tab-customers-active.223d8fd0.svg";